import React from "react";
import "./HomestayEvent.css";

const HomestayEvent = () => {
  return (
    <section className="homestay-event container-fluid py-5">
      <div className="homestay-wrapper mx-auto">

        <div className="row align-items-center g-4">

          {/* RIGHT IMAGES */}
          <div className="col-lg-6">
            <div className="image-stack">
              <img
                src="/assets/Events/Darjeeling1.jpeg"
                alt="Homestay Experience"
                className="img-main"
              />
              <img
                src="/assets/Events/Darjeeling2.jpeg"
                alt="Local Culture"
                className="img-overlay"
              />
            </div>
          </div>
          
           {/* LEFT CONTENT */}
          <div className="col-lg-6">
            <div className="content-box">
              <h2 className="event-title">
                Homestay Exposure Visit – <span>Lepchajagat</span>
              </h2>

              <p className="event-text">
                A Homestay Exposure Visit to Lepchajagat was organized by the Directorate of Tourism, offering an insightful glimpse into how community-led tourism can transform local livelihoods.
              </p>

              <p className="event-text">
                Hospitality practices, cultural storytelling, and sustainable models led by local women were closely observed and understood.
              </p>

              <p className="event-text highlight">
                Homestay tourism is emerging as a powerful pathway to women-led economic empowerment and rural ecosystem development in Jharkhand.
              </p>

              <div className="event-tags">
                <span>#HomestayTourism</span>
                <span>#WomenEmpowerment</span>
                <span>#JharkhandTourism</span>
                <span>#CapacityBuilding</span>
              </div>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default HomestayEvent;